import { useMutation } from "react-query";
import axios from "../axios";
import { ChangePasswordResponse } from "../../constants/types";

type ChangePasswordBody = {
    passwordLama: string;
    passwordBaru: string;
};

const changePassword = async (body: ChangePasswordBody) => {
    const response = await axios.post<ChangePasswordResponse>(
        "/api/password",
        body,
    );
    return response.data;
};

export default function useChangePassword() {
    return useMutation((body: ChangePasswordBody) => changePassword(body));
}
